import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_default/categories/$category")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div>
      <h1 className="text-xl font-bold">Category</h1>
    </div>
  );
}
